var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-sheet',{staticClass:"pa-8"},[_c('p',{staticClass:"text-h5"},[_vm._v(" Create POS ")]),_c('FormInput',{attrs:{"loading":_vm.loading,"warehouse":_vm.warehouse,"status-list":_vm.statusList},on:{"onSubmit":_vm.onSubmit,"onCancel":function($event){return _vm.$router.go(-1)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }